import { render, staticRenderFns } from "./LuSpecialDistrict.vue?vue&type=template&id=5882fa4b&"
import script from "./LuSpecialDistrict.vue?vue&type=script&lang=js&"
export * from "./LuSpecialDistrict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports